import O2oTrainplanAudit from './src/main.vue';

O2oTrainplanAudit.install = function(Vue) {
  Vue.component(O2oTrainplanAudit.name, O2oTrainplanAudit);
};

export default O2oTrainplanAudit;
